import React from "react"
import { Link } from "gatsby"
import { SEM_VIGNETTE } from "../utils/ads"

// Hero "céu noturno" de la home: presenta el sitio y manda a las dos secciones
// que concentran el tráfico (horóscopo y baralho cigano).
const HomeHero = () => (
  <div className="home-hero">
    <div className="home-hero-stars" aria-hidden="true" />
    <div className="home-hero-body">
      <div>
        <h1 className="title is-3">O que os astros dizem sobre você?</h1>
        <p className="subtitle is-6">
          Horóscopo do dia, mapa astral, tarot, baralho cigano, runas e muito mais —
          tudo grátis, sem cadastro.
        </p>
        <div className="home-hero-actions">
          <Link className="button is-primary" to="/horoscopo/">
            Ver meu signo
          </Link>
          <Link className="button is-light" to="/oraculo/baralho-cigano/" {...SEM_VIGNETTE}>
            Jogar o Baralho Cigano
          </Link>
        </div>
      </div>
    </div>
  </div>
)

export default HomeHero
